import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  hide = true;

  constructor(
    private authService: AuthService,
    private router: Router,
    private spinnerService: SpinnerService
  ) {}

  login(loginForm: NgForm) {
    this.spinnerService.showSpinner$.next(true);
    this.authService.login(loginForm.form.value).subscribe({
      next: () => {
        this.router.navigate(['/home']);
        this.spinnerService.showSpinner$.next(false);
      },
      error: () => {
        this.spinnerService.showSpinner$.next(false);
      },
    });
  }
}
